import { MAX_FOOTPRINT_SHAPES_PER_LEVEL } from '@alpinehomeair/common';

export const FOOTPRINT_SHAPE_LIMIT_MESSAGE = `A floor can have at most ${MAX_FOOTPRINT_SHAPES_PER_LEVEL} footprints`;

export const FOOTPRINT_HOLE_MESSAGE =
  'Footprints cannot enclose an open courtyard';

export const FOOTPRINT_HOLE_TOAST_ID = 'footprint-hole';
